{
  "App": "অ্যাপ",
  "Profile": "প্রোফাইল",
  "My Account": "মাই অ্যাকাউন্ট",
  "Contacts": "যোগাযোগসমূহ",
  "Preferences": "পছন্দসমূহ",
  "Family Language": "পারিবারিক ভাষা",
  "Program Consent": "প্রোগ্রামের সম্মতি",
  "Yes": "হ্যাঁ",
  "No": "না",
  "Not submitted": "জমা দেওয়া হয়নি",
  "See anything missing? Contact your Caring Adult": "কোনো কিছু বাদ পড়েছে? আপনার কেয়ারিং অ্যাডাল্টদের সাথে যোগাযোগ করুন",
  "Messages": "ম্যাসেজ",
  "Caring Adult for": "এর জন্য কেয়ারিং অ্যাডাল্ট",
  "Former Caring Adult for": "এর জন্য প্রাক্তন কেয়ারিং অ্যাডাল্ট",
  "Write your message here...": "এখানে আপনার ম্যাসেজটি লিখুন...",
  "I need help with": "আমার নিম্নলিখিতগুলোতে সাহায্যের প্রয়োজন",
  "Academic": "একাডেমিক",
  "After School/ Out of School": "আফটার স্কুল/আউট অফ স্কুল",
  "Applying for benefits": "লাভ/সুবিধাগুলির জন্য আবেদন করা",
  "Childcare": "চাইল্ডকেয়ার",
  "Employment / Adult Education": "কর্মসংস্থান/প্রাপ্তবয়স্ক শিক্ষা",
  "Food": "খাদ্য",
  "Housing": "আবাসন",
  "Legal services": "আইনি সেবা",
  "Material Resources / Clothing / Laundry": "সামগ্রীর সংস্থান/জামা কাপড়/লন্ড্রি",
  "Mental/emotional health": "মানসিক/আবেগিক স্বাস্থ্য",
  "Physical health/asthma": "শারীরিক স্বাস্থ্য/হাঁপানি",
  "Transportation": "পরিবহন",
  "Send": "পাঠান",
  "Today": "আজ",
  "No messages yet": "এখনও কোনো ম্যাসেজ আসেনি",
  "No messages": "কোনো ম্যাসেজ নেই",
  "Start a conversation below": "নীচে কথাবার্তা আরম্ভ করুন",
  "This Caring Adult is no longer available": "এই কেয়ারিং অ্যাডাল্ট আর উপলব্ধ নেই",
  "No longer available ": "আর উপলব্ধ নেই ",
  "Monday": "সোমবার",
  "Tuesday": "মঙ্গলবার",
  "Wednesday": "বুধবার",
  "Thursday": "বৃহস্পতিবার",
  "Friday": "শুক্রবার",
  "Saturday": "শনিবার",
  "Sunday": "রবিবার",
  "Emergency Contacts": "আপৎকালীন যোগাযোগের নম্বর",
  "Supervisor of Social Workers for the Bronx": "ব্রঙ্কসের সমাজসেবকদের তত্ত্বাবধায়ক",
  "Student Services Manager, High School District": "স্টুডেন্ট সার্ভিস ম্যানেজার, হাই স্কুল ডিস্ট্রিক্ট",
  "Social Worker, Central Crisis Support Team": "সমাজসেবক, সেন্ট্রাল ক্রাইসিস সাপোর্ট টিম (Central Crisis Support Team)",
  "Support Line": "সাপোর্ট লাইন",
  "Suicide and Crisis Lifeline": "আত্মহত্যা এবং ক্রাইসিস লাইফলাইন (Suicide and Crisis Lifeline)",
  "Emergencies": "আপৎকালীন অবস্থা",
  "If you are facing a life-threatening emergency and need help right now, call or text 911": "আপনি যদি কোনো জীবনের ঝুঁকিপূর্ণ আপৎকালীন অবস্থার সম্মুখীন হন এবং এই মুহূর্তেই সাহায্যের প্রয়োজন হয়, তাহলে 911 নম্বরে কল করুন বা টেক্সট করুন",
  "About New Visions": "New Visions সম্পর্কে",
  "Privacy and Terms": "গোপনীয়তা এবং শর্তাবলী",
  "Homepage": "হোমপেজ",
  "Home Page": "হোমপেজ",
  "My family": "মাই ফ্যামিলি",
  "Available Services": "উপলব্ধ পরিষেবাসমূহ",
  "Grade": "শ্রেণী",
  "School": "স্কুল",
  "Attendance this year": "এই বছরের উপস্থিতি",
  "Absences last 5 days": "বিগত 5 দিনে অনুপস্থিতি",
  "Caring Adult": "কেয়ারিং অ্যাডাল্ট",
  "Message": "ম্যাসেজ",
  "Not available": "উপলব্ধ নয়",
  "Not yet assigned": "এখনও দেওয়া হয়নি",
  "No absences": "অনুপস্থিতি নেই",
  "Phone not available": "ফোন উপলব্ধ নয়",
  "Email address not available": "ইমেইল অ্যাড্রেস উপলব্ধ নয়",
  "January": "জানুয়ারি",
  "February": "ফেব্রুয়ারি",
  "March": "মার্চ",
  "April": "এপ্রিল",
  "May": "মে",
  "June": "জুন",
  "July": "জুলাই",
  "August": "আগস্ট",
  "September": "সেপ্টেম্বর",
  "October": "অক্টোবর",
  "November": "নভেম্বর",
  "December": "ডিসেম্বর",
  "Sidenav": "সাইড নেভিগেশন",
  "Home": "হোম",
  "Log out": "লগ আউট করুন",
  "Accessibility": "অ্যাক্সেসযোগ্যতা",
  "Skip to main content": "এটি এড়িয়ে মূল বিষয়ে যান",
  "Email": "ইমেইল",
  "Phone": "ফোন",
  "Family Portal": "ফ্যামিলি পোর্টাল",
  "Every Child and Family is Known": "প্রতিটি শিশু ও পরিবার পরিচিত (ECFIK)",
  "Family Portal: Every Child and Family is Known": "ফ্যামিলি পোর্টাল: প্রতিটি শিশু ও পরিবার পরিচিত ",
  "Close menu": "মেনু বন্ধ করুন",
  "Open menu": "মেনু খুলুন",
  "Notes": "নোট",
  "Send message": "ম্যাসেজ পাঠান",
  "Languages": "ভাষাসমূহ",
  "Consent status": "সম্মতির স্থিতি",
  "Select": "নির্বাচন করুন",
  "Language selector": "ভাষা নির্বাচক",
  "Sorry": "দুঃখিত",
  "we couldn't find that page": "আমরা সেই পেজটি খুঁজে পাইনি",
  "You are not yet authorized to log in to the Family Portal. Please reach out to your Caring Adult for access.": "আপনি এখনও পারিবারিক পোর্টালে লগ ইন করার জন্য অনুমোদিত নন। অ্যাক্সেসের জন্য আপনার যত্নশীল প্রাপ্তবয়স্কদের সাথে যোগাযোগ করুন।"
}